import DataObjectField from '@/utilities/classes/data-object-field';

const buildTenantAffidavitSubmissionDataObject = (vData) => {

  const fields = [
    new DataObjectField(vData.FullName, 8),
    new DataObjectField(vData.SignatureDate, 9),
    new DataObjectField(vData.applicantId, 14),
    new DataObjectField(vData.TFAInfoCheckbox, 16),
  ];

  const dataObject = {
    qdbapi: {
      udata : "EVICTION_DIVERSION_TFA_APPLICATION",
      clist: "32",
      field: fields,
    },
  };
  return dataObject;
};

export default buildTenantAffidavitSubmissionDataObject;
